import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=5d4c4ad2&lang=pug&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4c4ad2')) {
      api.createRecord('5d4c4ad2', component.options)
    } else {
      api.reload('5d4c4ad2', component.options)
    }
    module.hot.accept("./finish.vue?vue&type=template&id=5d4c4ad2&lang=pug&", function () {
      api.rerender('5d4c4ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/finish.vue"
export default component.exports